/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateShadowMCPInventoryServerNameForm = {
  name: string;
  projectId: string;
  serverUrl: string;
};

/** @internal */
export type UpdateShadowMCPInventoryServerNameForm$Outbound = {
  name: string;
  project_id: string;
  server_url: string;
};

/** @internal */
export const UpdateShadowMCPInventoryServerNameForm$outboundSchema:
  z.ZodMiniType<
    UpdateShadowMCPInventoryServerNameForm$Outbound,
    UpdateShadowMCPInventoryServerNameForm
  > = z.pipe(
    z.object({
      name: z.string(),
      projectId: z.string(),
      serverUrl: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectId: "project_id",
        serverUrl: "server_url",
      });
    }),
  );

export function updateShadowMCPInventoryServerNameFormToJSON(
  updateShadowMCPInventoryServerNameForm:
    UpdateShadowMCPInventoryServerNameForm,
): string {
  return JSON.stringify(
    UpdateShadowMCPInventoryServerNameForm$outboundSchema.parse(
      updateShadowMCPInventoryServerNameForm,
    ),
  );
}
